import React, { useState } from 'react';

const FAQS = [
  {
    q: 'How do I find my school kit?',
    a: 'Use the search bar on the home page to type your school name. Once you select your school, choose your child\'s grade to see the exact kit prepared for that class.',
  },
  {
    q: 'Can I customize the items in a kit?',
    a: 'Yes! When you open a kit, you can adjust quantities for each item or remove items you already have at home. Optional items can also be added or skipped.',
  },
  {
    q: 'What if my school is not listed?',
    a: 'Click "Upload My List" on the home page or use the "Can\'t find your school?" section. Send us your supply list and we\'ll build a custom kit and get back to you within 24–48 hours.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major credit and debit cards (Visa, Mastercard, American Express, Discover) processed securely at checkout.',
  },
  {
    q: 'How long does shipping take?',
    a: 'Standard shipping typically takes 5–10 business days. Expedited options are available at checkout depending on your location.',
  },
  {
    q: 'Can I track my order?',
    a: 'Yes. After placing your order you will receive a confirmation email with your order number. You can also track your order anytime at the "Track Order" link in the navigation.',
  },
  
  {
    q: 'Are the kits available year-round?',
    a: 'Kits are available year-round, though inventory is highest during the back-to-school season (July–September). Individual supplies are always in stock.',
  },
];

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        borderRadius: 10,
        border: '1.5px solid #e5e7eb',
        marginBottom: '0.75rem',
        overflow: 'hidden',
        background: '#fff',
      }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          textAlign: 'left',
          padding: '1rem 1.25rem',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 700,
          fontSize: '0.97rem',
          color: '#111827',
        }}
      >
        {q}
        <span style={{ fontSize: '1.2rem', color: '#6b7280', lineHeight: 1 }}>{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div style={{ padding: '0 1.25rem 1rem', color: '#374151', fontSize: '0.92rem', lineHeight: 1.65 }}>
          {a}
        </div>
      )}
    </div>
  );
};

const FAQsPage = () => (
  <div className="container" style={{ padding: '2.5rem 1rem', maxWidth: 720 }}>
    <div className="page-header">
      <h1>Frequently Asked Questions</h1>
      <p>Everything you need to know about Schoolkit2go</p>
    </div>
    <div style={{ marginTop: '2rem' }}>
      {FAQS.map((item, i) => (
        <FAQItem key={i} q={item.q} a={item.a} />
      ))}
    </div>
    <div style={{ marginTop: '2rem', padding: '1.25rem', background: '#eff6ff', borderRadius: 10, textAlign: 'center', color: '#1d4ed8', fontSize: '0.92rem' }}>
      Still have questions? <a href="/contact" style={{ fontWeight: 700, color: '#2563eb' }}>Contact us</a> and we'll be happy to help.
    </div>
  </div>
);

export default FAQsPage;
